'use client';

import { useActionState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Button, Card } from 'konsta/react';
import { createMiniAppBookingInvitationAction } from './actions';

type State = { token?: string; error?: string };

export function BookingInvitationButton({ bookingId }: { bookingId: string }) {
  const [state, action, pending] = useActionState<State, FormData>(async (_previous, formData) => {
    try {
      const result = await createMiniAppBookingInvitationAction(formData);
      return { token: result.token };
    } catch (error) {
      return { error: error instanceof Error ? error.message : '建立邀請失敗' };
    }
  }, {});
  const invitationUrl = state.token && typeof window !== 'undefined'
    ? `${window.location.origin}/invite/${encodeURIComponent(state.token)}`
    : null;

  return (
    <div className="mt-2">
      <form action={action}>
        <input type="hidden" name="bookingId" value={bookingId} />
        <Button type="submit" small outline rounded disabled={pending}>{pending ? '建立中…' : '邀請同行會員'}</Button>
      </form>
      {state.error && <p className="text-xs text-red-600">{state.error}</p>}
      {invitationUrl && <Card raised className="mt-2 text-center">
        <QRCodeSVG value={invitationUrl} size={148} className="mx-auto" />
        <p className="mt-2 break-all text-xs">{invitationUrl}</p>
        <Button small rounded onClick={() => navigator.share?.({ title: '課程同行邀請', url: invitationUrl })}>分享邀請</Button>
      </Card>}
    </div>
  );
}
